import { Notation } from '@capdesk/camo'
import { FORMAT_LOCALE } from '@capdesk/utils'

const formatNumber = (value: number, options?: Intl.NumberFormatOptions) =>
  new Intl.NumberFormat(FORMAT_LOCALE, options).format(value)

const formatCompactNumber = Intl.NumberFormat(FORMAT_LOCALE, { notation: Notation.COMPACT }).format

export { formatNumber, formatCompactNumber }
